export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_ASYNC = `${REGISTER_USER}_ASYNC`;

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_ASYNC = `${LOGIN_USER}_ASYNC`;

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_ASYNC = `${LOGOUT_USER}_ASYNC`;

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_ASYNC = `${RESET_PASSWORD}_ASYNC`;

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_ASYNC = `${FORGOT_PASSWORD}_ASYNC`;
export const RESET_FORGOT_PASSWORD = 'RESET_FORGOT_PASSWORD';

export const VALIDATE_RESET_CODE = 'VALIDATE_RESET_CODE';
export const VALIDATE_RESET_CODE_ASYNC = `${VALIDATE_RESET_CODE}_ASYNC`;

export const LOGIN_GOOGLE = 'LOGIN_GOOGLE';
export const LOGIN_GOOGLE_ASYNC = `${LOGIN_GOOGLE}_ASYNC`;

export const LOGIN_FACEBOOK = 'LOGIN_FACEBOOK';
export const LOGIN_FACEBOOK_ASYNC = `${LOGIN_FACEBOOK}_ASYNC`;

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const UPDATE_USER_DATA_ASYNC = `${UPDATE_USER_DATA}_ASYNC`

export const REFRESH_USER_DATA = 'REFRESH_USER_DATA'
export const REFRESH_USER_DATA_ASYNC = `${REFRESH_USER_DATA}_ASYNC`

export const LOGIN_APPLE = 'LOGIN_APPLE';
export const LOGIN_APPLE_ASYNC = `${LOGIN_APPLE}_ASYNC`;

export const REFRESH_user_DATA = 'REFRESH_user_DATA'
export const REFRESH_uSER_DATA_ASYNC = 'REFERESH_uSER_DATA';

export const DELETE_USER = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ASYNC = 'DELETE_USER_SUCCESS_ASYNC';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_ASYNC = `${REFRESH_TOKEN}_ASYNC`;